import { render, staticRenderFns } from "./LocaleDataReport.vue?vue&type=template&id=8d49d032&scoped=true"
import script from "./LocaleDataReport.vue?vue&type=script&lang=js"
export * from "./LocaleDataReport.vue?vue&type=script&lang=js"
import style0 from "./LocaleDataReport.vue?vue&type=style&index=0&id=8d49d032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d49d032",
  null
  
)

export default component.exports